/* Ohbears cart drawer.
   - Add to cart without leaving the page, then opens the drawer (or goes to the cart page, or stays: section setting)
   - The header cart icon opens the drawer (the cart page stays as a fallback without JavaScript)
   - Quantity, remove, subscription, discount code, note and add-on controls update the drawer in place
   - Announcement countdown timer
   Uses Shopify's Ajax Cart API with Section Rendering, no dependencies. */
(function () {
  'use strict';

  var SECTION = 'ob-cart-drawer';
  var lastFocus = null;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function drawer() { return document.querySelector('[data-ob-drawer]'); }
  function panel() { var d = drawer(); return d && d.querySelector('.ob-drawer__panel'); }

  function focusables(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function open() {
    var d = drawer();
    if (!d) return false;
    if (!d.classList.contains('is-open')) lastFocus = document.activeElement;
    d.classList.add('is-open');
    document.documentElement.classList.add('ob-lock');
    var openMenu = document.querySelector('.ob-nav__mobile[open]');
    if (openMenu) openMenu.removeAttribute('open');
    var closeBtn = d.querySelector('.ob-drawer__head [data-ob-drawer-close]');
    window.setTimeout(function () { (closeBtn || panel()).focus(); }, 50);
    return true;
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ob-lock');
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  function updateCount(count) {
    document.querySelectorAll('a.ob-iconbtn[href*="view=ohbears"]').forEach(function (link) {
      var bubble = link.querySelector('.ob-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'ob-count';
          link.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
      link.setAttribute('aria-label', 'Panier, ' + count + ' article' + (count > 1 ? 's' : ''));
    });
    document.querySelectorAll('.ob-nav__menu a[href*="view=ohbears"]').forEach(function (a) {
      a.textContent = a.textContent.replace(/\(\d+\)/, '(' + count + ')');
    });
  }

  function render(html) {
    var d = drawer();
    if (!d || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ob-drawer-inner]');
    var current = d.querySelector('[data-ob-drawer-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(parseInt(fresh.dataset.obCount, 10) || 0);
      tickTimers();
    }
  }

  function setLoading(on) {
    var inner = document.querySelector('[data-ob-drawer-inner]');
    if (inner) inner.classList.toggle('is-loading', on);
  }

  function showError(form, message) {
    var box = form.querySelector('[data-ob-form-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'ob-form-error';
      box.setAttribute('role', 'alert');
      box.setAttribute('data-ob-form-error', '');
      form.appendChild(box);
    }
    box.textContent = message;
  }

  function clearError(form) {
    var box = form.querySelector('[data-ob-form-error]');
    if (box) box.remove();
  }

  /* POST a JSON body to a cart endpoint and re-render the drawer from the bundled section */
  function cartPost(endpoint, body) {
    setLoading(true);
    body.sections = [SECTION];
    body.sections_url = window.location.pathname;
    return fetch(routeRoot() + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.sections && data.sections[SECTION]) {
          render(data.sections[SECTION]);
        } else {
          setLoading(false);
        }
        return data;
      })
      .catch(function () { setLoading(false); return null; });
  }

  function afterAdd(data) {
    var mode = (drawer() && drawer().getAttribute('data-ob-after-add')) || 'drawer';
    if (mode === 'page') {
      window.location.href = routeRoot() + 'cart?view=ohbears';
      return;
    }
    if (data.sections && data.sections[SECTION]) {
      render(data.sections[SECTION]);
      if (mode === 'drawer') open();
    } else {
      window.location.href = routeRoot() + 'cart?view=ohbears';
    }
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"]');
    var fd = new FormData(form);
    fd.delete('return_to');
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    clearError(form);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }

    return fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          showError(form, r.data.description || r.data.message || "Impossible d'ajouter ce produit pour le moment.");
          return;
        }
        afterAdd(r.data);
      })
      .catch(function () { form.submit(); })
      .then(function () {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
  }

  function changeLine(key, quantity) {
    return cartPost('cart/change.js', { id: key, quantity: quantity });
  }

  /* Subscription: switch a line to a selling plan, or back to one-time with an empty plan */
  function changePlan(key, quantity, plan) {
    return cartPost('cart/change.js', { id: key, quantity: quantity, selling_plan: plan ? parseInt(plan, 10) : null });
  }

  /* Discount codes: the cart keeps the full list, so send every code that should stay applied */
  function setCodes(codes, attempted) {
    return cartPost('cart/update.js', { discount: codes.join(',') }).then(function (data) {
      if (!attempted || !data || !data.discount_codes) return;
      var hit = data.discount_codes.filter(function (c) { return c.code.toLowerCase() === attempted.toLowerCase(); })[0];
      if (hit && hit.applicable) return;
      var keep = codes.filter(function (c) { return c.toLowerCase() !== attempted.toLowerCase(); });
      return setCodes(keep).then(function () {
        var form = document.querySelector('[data-ob-discount]');
        if (!form) return;
        var err = document.createElement('p');
        err.className = 'obd-err';
        err.setAttribute('role', 'alert');
        err.textContent = 'Ce code n’est pas valide ou ne s’applique pas à ton panier.';
        form.insertAdjacentElement('afterend', err);
      });
    });
  }
  function currentCodes(form) {
    var raw = (form && form.getAttribute('data-codes')) || '';
    return raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }

  /* Order note: saved in the background, no re-render so typing is not interrupted */
  var noteTimer = null;
  function saveNote(value) {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      fetch(routeRoot() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: value })
      });
    }, 500);
  }

  /* Announcement countdown: one deadline per visit, shared by every render */
  function timerDeadline() {
    var d = drawer();
    var minutes = d && parseInt(d.getAttribute('data-ob-timer-minutes'), 10);
    if (!minutes) return 0;
    var key = 'obDrawerTimerEnd';
    var end = 0;
    try { end = parseInt(window.sessionStorage.getItem(key), 10) || 0; } catch (err) { end = 0; }
    if (!end) {
      end = Date.now() + minutes * 60000;
      try { window.sessionStorage.setItem(key, String(end)); } catch (err) { /* private mode */ }
    }
    return end;
  }
  var deadline = 0;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickTimers() {
    var els = document.querySelectorAll('[data-ob-timer]');
    if (!els.length) return;
    if (!deadline) deadline = timerDeadline();
    if (!deadline) return;
    var left = Math.max(0, Math.round((deadline - Date.now()) / 1000));
    var h = Math.floor(left / 3600);
    var text = (h ? h + ':' + pad(Math.floor(left % 3600 / 60)) : pad(Math.floor(left / 60))) + ':' + pad(left % 60);
    els.forEach(function (el) { el.textContent = text; });
  }
  window.setInterval(tickTimers, 1000);
  tickTimers();

  /* Submit: product forms on the page, suggestions inside the drawer, discount code */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!drawer()) return;
    if (form.hasAttribute('data-ob-discount')) {
      e.preventDefault();
      var input = form.querySelector('input[name="code"]');
      var code = input && input.value.trim();
      if (!code) return;
      var codes = currentCodes(form);
      if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) codes.push(code);
      setCodes(codes, code);
      return;
    }
    if (form.closest('[data-ob-product]') || form.hasAttribute('data-ob-upsell') || form.hasAttribute('data-ob-cart-form')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  /* Clicks: open from cart links, close, quantity, subscription upgrade, remove code */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var closer = t.closest('[data-ob-drawer-close]');
    if (closer) {
      var href = closer.getAttribute('href');
      if (!href || href.charAt(0) === '#') {
        if (!href) e.preventDefault();
      }
      close();
      return;
    }
    var qty = t.closest('[data-ob-drawer-qty]');
    if (qty) {
      e.preventDefault();
      changeLine(qty.dataset.key, parseInt(qty.dataset.obDrawerQty, 10) || 0);
      return;
    }
    var plan = t.closest('[data-ob-plan]');
    if (plan) {
      e.preventDefault();
      changePlan(plan.dataset.key, parseInt(plan.dataset.qty, 10) || 1, plan.getAttribute('data-ob-plan'));
      return;
    }
    var rm = t.closest('[data-ob-discount-remove]');
    if (rm) {
      e.preventDefault();
      var form = document.querySelector('[data-ob-discount]');
      var gone = rm.getAttribute('data-ob-discount-remove').toLowerCase();
      setCodes(currentCodes(form).filter(function (c) { return c.toLowerCase() !== gone; }));
      return;
    }
    var cartLink = t.closest('a[href*="/cart?view=ohbears"]');
    if (cartLink && !cartLink.closest('[data-ob-drawer]')) {
      if (open()) e.preventDefault();
    }
  });

  /* Changes: frequency menu, add-on checkbox */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-ob-plan-select]')) {
      changePlan(t.dataset.key, parseInt(t.dataset.qty, 10) || 1, t.value);
      return;
    }
    if (t.matches && t.matches('[data-ob-addon]')) {
      if (t.checked) {
        cartPost('cart/add.js', { items: [{ id: parseInt(t.getAttribute('data-ob-addon'), 10), quantity: 1 }] });
      } else if (t.dataset.key) {
        changeLine(t.dataset.key, 0);
      }
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-ob-note]')) saveNote(e.target.value);
  });

  /* Keyboard: Escape closes, Tab stays inside the drawer */
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var items = focusables(panel());
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Theme editor: show the drawer while its section or one of its blocks is selected */
  function inDrawer(e) { return e.target && e.target.closest && (e.target.closest('[data-ob-drawer]') || (e.target.querySelector && e.target.querySelector('[data-ob-drawer]'))); }
  document.addEventListener('shopify:section:select', function (e) { if (inDrawer(e)) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (inDrawer(e)) close(); });
  document.addEventListener('shopify:block:select', function (e) { if (inDrawer(e)) open(); });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-ob-drawer]')) { deadline = 0; open(); tickTimers(); }
  });

  window.ObDrawer = { open: open, close: close, refresh: function () { return cartPost('cart/update.js', {}); } };
})();
